var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValoresMision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editor_choice_FILL0_wght300_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.2979 115.312V76.4117L17.1982 48.6874L39.3243 12.8125H83.675L105.801 48.6874L88.7013 76.4117V115.312L61.4996 106.097L34.2979 115.312V115.312ZM41.9853 104.441L61.4996 97.9466L81.014 104.441V84.5623H41.9853V104.441ZM43.6115 20.4999L26.1865 48.6874L43.6115 76.8749H79.3878L96.8128 48.6874L79.3878 20.4999H43.6115ZM56.1184 67.7483L39.7481 51.5061L45.2278 46.0265L56.1184 56.9171L77.7715 35.1359L83.2512 40.4874L56.1184 67.7483Z",
    fill: "#9BCB49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValoresMision);
export default __webpack_public_path__ + "static/media/valores-mision.662f5f8c97c292d022b61d7a60e3a2e1.svg";
export { ForwardRef as ReactComponent };